/**
 * Caminho SPA atual para telemetria de presença (emit `users` no socket).
 * Atualizado por `TeamPresenceRouteSync` dentro do Router.
 */

let currentPathname = typeof window !== "undefined" ? `${window.location.pathname}${window.location.search || ""}` : "/";
const listeners = new Set();

/** @param {() => void} listener */
export function subscribeTeamPresenceRoute(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/**
 * @param {string} pathname - pathname + opcional search (ex.: /chat/12)
 */
export function setTeamPresencePathname(pathname) {
  if (pathname === currentPathname) return;
  currentPathname = pathname;
  for (const l of listeners) l();
}

export function getTeamPresencePathname() {
  return currentPathname;
}
